import styled from 'styled-components';

const Frame = styled('div')`
  padding: 0 16px 24px;
`;

export { Frame };
